export default function useStoreProduct() {
  function getValidUrl(url: string) {
    if (url.length > 0 && url.indexOf('http') === -1) return `https://${url}`;
    return url || '';
  }

  return {
    getValidUrl,
  };
}
